import name from './name'

const selectSliceData = state => state[name]

const selectToolPathwayCurrentContent = state => selectSliceData(state).toolPathway.currentContent

export {
  selectToolPathwayCurrentContent
}
